module.exports = __webpack_public_path__ + "media/ALERT.ea051bfc.mp3";